export const isCommentNotFoundError = (errorMessage?: string): boolean => {
	if (errorMessage) {
		const reasonStartIdx = errorMessage.lastIndexOf(':') + 1;
		const reasonMessage = errorMessage.substring(reasonStartIdx, errorMessage.length).trim();
		return reasonMessage === 'No comment found for the given id';
	}
	return false;
};
